'use client';

import { c as _c } from "react/compiler-runtime";
import { ReviewList } from '@/features/hospital/ui/templates';
import { useParams, useSearchParams } from 'next/navigation';
import { HospitalReviewSortEnum } from '@/entities/hospital/types/type';
import { useInfiniteQueryReviewDetail } from '@/entities/hospital/hooks/queries';
import { parseReviewCategoryGroup } from '@/entities/hospital/lib/selection-evidence';
import { DetailReview } from '@/widgets/review-detail/ui/molecules';
import { useEffect } from 'react';
import { useFeaturesHospitalDataStore, useFeaturesHospitalStore } from '@/features/hospital/model/store';
const ReviewDetailTemplate = () => {
  const $ = _c(20);
  const hospitalId = Number(useParams().id);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("subject") ?? "";
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const subject = t0;
  let t1;
  if ($[2] !== searchParams) {
    t1 = searchParams.get("major") ?? "";
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const major = t1;
  let t2;
  if ($[4] !== searchParams) {
    t2 = searchParams.get("minor") ?? "";
    $[4] = searchParams;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const minor = t2;
  let t3;
  if ($[6] !== searchParams) {
    t3 = parseReviewCategoryGroup(searchParams.get("group"));
    $[6] = searchParams;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const group = t3;
  const {
    resetReviewFilter
  } = useFeaturesHospitalStore();
  const {
    resetReviewFilterData
  } = useFeaturesHospitalDataStore();
  const {
    data: reviewDetailList,
    fetchNextPage,
    hasNextPage
  } = useInfiniteQueryReviewDetail(hospitalId, 1, 10, HospitalReviewSortEnum.LATEST, subject, major, minor, group);
  const reviewList = reviewDetailList?.pages.flatMap(_temp) ?? [];
  const isEmpty = reviewList.length === 0;
  const applyMatchHighlight = Boolean(major && minor);
  let t4;
  let t5;
  if ($[8] !== resetReviewFilter || $[9] !== resetReviewFilterData) {
    t4 = () => () => {
      resetReviewFilter();
      resetReviewFilterData();
    };
    t5 = [resetReviewFilter, resetReviewFilterData];
    $[8] = resetReviewFilter;
    $[9] = resetReviewFilterData;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  const t6 = "flex-1 flex flex-col";
  const T0 = ReviewList;
  const t7 = hasNextPage ?? false;
  const t8 = true;
  let t9;
  if ($[12] !== applyMatchHighlight) {
    t9 = (review, index) => <DetailReview key={review.id ?? `review-${index}`} score={review.score} author={review.author} createAt={review.createAt} content={review.content} matchContents={review.matchContents} applyMatchHighlight={applyMatchHighlight} />;
    $[12] = applyMatchHighlight;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = reviewList.map(t9);
  let t11;
  if ($[14] !== T0 || $[15] !== fetchNextPage || $[16] !== isEmpty || $[17] !== t10 || $[18] !== t7) {
    t11 = <div className={t6}><T0 isEmpty={isEmpty} fetchNextPage={fetchNextPage} hasNextPage={t7} isCollection={t8}>{t10}</T0></div>;
    $[14] = T0;
    $[15] = fetchNextPage;
    $[16] = isEmpty;
    $[17] = t10;
    $[18] = t7;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};
export default ReviewDetailTemplate;
function _temp(page) {
  return page.contents;
}